import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getAllPosts, formatPostDate } from '../utils/blog';

export default function Blog() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getAllPosts().then((loaded) => {
      if (!cancelled) setPosts(loaded);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <Helmet defer={false}>
        <title>Blog | Hormonely</title>
        <meta name="description" content="Plain English articles on hormone health across every decade, for men and women in their 30s, 40s, 50s and beyond." />
      </Helmet>

      <div className="page-hero">
        <div className="container page-hero__inner">
          <div className="eyebrow" style={{ color: 'var(--clay-lt)', marginBottom: '16px' }}>The Hormonely Blog</div>
          <h1 className="page-hero__title">Hormone health, <em>explained plainly.</em></h1>
          <p className="page-hero__sub">Articles on what's changing in your body, decade by decade — written for real people, not clinicians.</p>
        </div>
      </div>

      <section className="section section--white">
        <div className="container">
          {!posts && (
            <p style={{ color: 'var(--stone)' }}>Loading articles…</p>
          )}

          {posts && posts.length === 0 && (
            <p style={{ color: 'var(--stone)' }}>No articles published yet — check back soon.</p>
          )}

          {posts && posts.length > 0 && (
            <div className="blog-grid">
              {posts.map((post) => (
                <Link key={post.slug} to={`/blog/${post.slug}`} className="blog-card">
                  <div className="blog-card__date">{formatPostDate(post.date)}</div>
                  <div className="blog-card__title">{post.title}</div>
                  <div className="blog-card__excerpt">{post.excerpt}</div>
                  <span className="blog-card__arrow">Read more →</span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
